import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
  VENDOR_MOBILE_NO,
  GENERATE_OTP,
  CHECK_OTP,
  Q_DOC_REPORT,
} from "./actionTypes";
import {
  apiError,
  VendorMobileSuccessful,
  generateOTPSuccessful,
  CheckOTPSuccessful,
  QDocReportSuccessful,
} from "./actions";
// import Swal from "sweetalert2";

// AUTH related methods
import { simplePost, VendorLogin, getList } from "../../helpers/Helper";

//If user is login then dispatch redux action's are directly from here.
function* vendorMobileNo({ payload: { token } }) {
  try {
    const response = yield call(
      simplePost,
      "/requestforquotation/vendorloginmobile",
      { token }
    );

    yield put(VendorMobileSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* generateOTP({ payload: { token } }) {
  try {
    const response = yield call(
      simplePost,
      "/requestforquotation/vendorlogincheck",
      { token }
    );

    yield put(generateOTPSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* CehckOTP({ payload: { data, history } }) {
  try {
    const response = yield call(
      VendorLogin,
      "/requestforquotation/vendorlogin",
      data
    );
    if (response.status === 200) {
      yield put(CheckOTPSuccessful(response.data));
      history.push("/VendorQuotation/" + data.token);
    }
  } catch (error) {
    // Swal.fire({
    //   icon: "error",
    //   text: "Sorry, Please check your OTP!",
    // });
    yield put(apiError(error));
  }
}
function* GetVendQDocReport({ payload: { QToken } }) {
  try {
    const response = yield call(getList, "/quotation/token/" + QToken);

    yield put(QDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
export function* watchVenodrMobileNo() {
  yield takeEvery(VENDOR_MOBILE_NO, vendorMobileNo);
}
export function* watchgenerateOTP() {
  yield takeEvery(GENERATE_OTP, generateOTP);
}
export function* watchCheckOTP() {
  yield takeEvery(CHECK_OTP, CehckOTP);
}
export function* watchQDocReport() {
  yield takeEvery(Q_DOC_REPORT, GetVendQDocReport);
}

function* VendorQuotationSaga() {
  yield all([
    fork(watchVenodrMobileNo),
    fork(watchgenerateOTP),
    fork(watchCheckOTP),
    fork(watchQDocReport),
  ]);
}

export default VendorQuotationSaga;
